import { Mobile, Burger, Scrollbar } from '../core'

export default {

  init() {
    /* Burger */
    let obj = this
    obj.burger = new Burger('.header__burger', {
      onToggle: function() {
        if (obj.burger.isExpanded) {
          $('.header__content').prop('hidden', false)
          requestAnimationFrame(function() {
            $('body').addClass('--menu-open')
          })
          document.ontouchmove = function (e) {
            e.preventDefault();
          }
        } else {
          $('body').removeClass('--menu-open')
          document.ontouchmove = function (e) {
            return true;
          }
        }
      },
    })

    $('.header__brand').each(function(e) {
      $('.header .header__content__container').prepend($(this).clone())
    });

    $('header .main-menu__item--parent').each(function(e) {
      var link = $(this).find('> a')
      link.removeAttr('href')
      var button = $('<button class="return-main-menu">' + link.html() + '</button>')
      $(this).find('.main-menu__sub-menu').prepend(button)
    });

    $('.return-main-menu').click(function(e) {
      $('header .main-menu__item.--open').removeClass('--open')
      $(this).closest('.main-menu').removeClass('--second-level')
      $(this).closest('.header__content').removeClass('--second-level')
      return false
    });

    $('header .main-menu__item--parent > a').click(function(e) {
      $('header .main-menu__item.--open').removeClass('--open')
      $(this).closest('.main-menu__item').addClass('--open')
      $(this).closest('.main-menu').addClass('--second-level')
      $(this).closest('.header__content').addClass('--second-level')
      return false
    });

    $('header .main-menu__sub-menu__link, header .main-menu__link').hover(function(e) {
      $('header .main-menu__sub-menu__link').removeClass('--on-top')
      $(this).addClass('--on-top')
    });

    $('header .main-menu__sub-menu--1').each(function() {
      $(this).children().wrapAll('<div class="submenu-scrollable-area"></div>')
      let content_results = new Scrollbar($(this).find('.submenu-scrollable-area'), {
        direction: 'vertical',
        desktop: true,
        mobile: true,
      })
      $(this).prev('.main-menu__link').click(function() {
        content_results.update();
      })

      var return_button = $(this).find('.return-main-menu');
      $(this).prepend(return_button)
      //return_button.remove();

      var illustration = $(this).find('.item-illustration');
      $(this).append(illustration)
      //illustration.remove();

    })
  }
}
